import { createUseStyles } from 'react-jss';

const styles = {
  subTitleStyle: {
    color: 'var(--sapContent_LabelColor)',
    fontFamily: 'var(--sapFontFamily)',
    fontWeight: '400',
    fontSize: 'var(--sapFontSmallSize)',
    paddingTop: '3px'
  },
  customTimelineItemDiv: {
    marginTop: '-32px',
    wordBreak: 'break-all'
  },
  badge: {
    float: 'right'
  },
  supplier: {
    marginTop: 0,
    marginBottom: 0,
    fontWeight: '400'
  },
  comment: { padding: '0.2rem 0.2rem 0.2rem 0' },
  commentAnwser: { border: '1.5px solid var(--sapButton_Accept_BorderColor)', borderRadius: `4px` }
};

export const useStyles = createUseStyles(styles, {
  name: 'CustomTimeline'
});
